import React, { useState } from "react";
import { TimePicker } from "antd";

const FloatTimePicker = (props) => {
    const {
        id,
        value,
        onChange,
        label,
        placeholder,
        required,
        popupClassName,
        format,
        disabled,
        disabledDate,
        allowClear,
        className,
        size,
        onBlur,
    } = props;

    const [focus, setFocus] = useState(false);

    let new_placeholder = !placeholder ? label : placeholder;

    let isOccupied = focus || (value && value.length !== 0);

    let labelClass = isOccupied ? "label float-label" : "label";

    let requiredMark = required ? <span className="text-danger">*</span> : null;

    return (
        <div
            id={id ?? ""}
            className={`float-wrapper float-time-picker ${className ?? ""}`}
            onBlur={() => setFocus(false)}
            onFocus={() => setFocus(true)}
        >
            <TimePicker
                onChange={onChange}
                value={value ? value : null}
                size={size ?? "middle"}
                placeholder={[""]}
                popupClassName={popupClassName ?? ""}
                format={format ? format : "HH:mm:ss"}
                allowClear={allowClear ?? false}
                onBlur={(date, dateString) => {
                    if (onBlur) {
                        onBlur(date, dateString);
                    }
                }}
                disabled={disabled ? disabled : false}
                disabledDate={(current) => {
                    if (disabledDate) {
                        return disabledDate(current);
                    } else {
                        return false;
                    }
                }}
            />

            <label className={labelClass}>
                {isOccupied ? label : new_placeholder} {requiredMark}
            </label>
        </div>
    );
};

export default FloatTimePicker;
